module.exports = __webpack_public_path__ + "img/ff6.de0603a2.jpg";